import { makeStyles } from "tss-react/mui";

export const useNWONProcessStepsStyles = makeStyles()((theme) => ({
  wrapper: {
    marginTop: theme.spacing(0),
    display: "flex",
    justifyContent: "center",
  },
  itemWrapper: {
    display: "flex",
    flexDirection: "column",
    alignContent: "flex-start",
    justifyContent: "flex-start",
    padding: theme.spacing(0, 2),
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(3),
      padding: theme.spacing(0),
    },
  },
  icon: {
    "& > svg": {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
  },
  headline: {
    marginTop: theme.spacing(1.5),
  },
  text: {
    marginTop: theme.spacing(0.5),
  },
}));
